import { GenericService } from '../GenericService'

class MediaFileService extends GenericService {
    constructor() {
        super('/api/admin/media')
    }

    getImageUploadUrl = (data) =>
        this.post('/api/admin/media/getImageUploadUrl', data)
}

const mediaFileService = new MediaFileService()
export default mediaFileService
